'use client';
import ProductCard from '@/components/productCard';
import CDNImage from '@/components/cdnImage/cdnImage';
import { pxToVw } from '@/components/productCard/common/utils';
import { ProductType } from '@/components/productCard/index.interface';
import { getExposureRecord, sendClickTrack } from '../../tempo_track';
import style from './style.module.scss';

type Props = {
  moduleData: any;
  localInfo: any;
  pageName: string;
  floorIndex: number;
  pageCode: string;
};

const adaptiveStyle = {
  bgImageWidth: pxToVw(375),
  bgImageHeight: pxToVw(228),
  productListTop: pxToVw(72),
  productCardWidth: pxToVw(98),
  productCardHeight: pxToVw(148),
  skuImgWidth: pxToVw(98),
  skuImgHeight: pxToVw(98),
  gap: pxToVw(8),
};

export default function Module({ moduleData, localInfo, pageName, floorIndex, pageCode }: Props) {
  // console.log('横滑商品-小',JSON.stringify(moduleData),pageName)
  // 初始化页面配置对象
  const pageConfig: any = {};
  const exposureRecord = getExposureRecord(pageCode);
  // 配置初始化函数，解析模块数据
  const initConfig = (moduleData: any) => {
    // 从模块数据中提取产品池数据
    pageConfig.data = moduleData.dataBatch?.productPool[0].productPool || [];
    // 提取背景图片配置
    pageConfig.backgroundImg = moduleData.dataBatch?.productPool[0].backgroundImg || {};
  };
  initConfig(moduleData);
  if (!Array.isArray(pageConfig.data) || pageConfig.data.length === 0) {
    return null;
  }

  const genEventTrackingInfo = (product: any, index: number) => {
    const eventTrackingInfo = {} as { [key: string]: any };
    const json_param = {
      skuid: product.skuId,
      index: index,
      pos: floorIndex,
      page_id: 'cms_' + pageCode,
      moduleInstanceId: 'up-horizontal-product-small',
      propoolid: product.productPoolId,
      algo_rd_inf: product.algoRdInfo || '',
      broker_info: product.brokerInfo ? JSON.stringify(product.brokerInfo) : '',
    };

    // 元素露出50%停留300ms触发
    const expConfig = {
      useClick: false,
      stay_duration: 0.3,
      repeated: false,
      area_rate: 0.5,
    };

    eventTrackingInfo['productClickPoint'] = () =>
      sendClickTrack.cms_TempoPage_UpHorizontalProductPoolSmall_Click(json_param);
    eventTrackingInfo['productExpConfig'] = {
      event_id: exposureRecord.cms_TempoPage_UpHorizontalProductPoolSmall_Expo,
      config: expConfig,
      json_param: json_param,
    };
    return eventTrackingInfo;
  };

  return (
    <div className={style['up-horizontal-product-small']}>
      <CDNImage
        // @ts-ignore
        src={pageConfig.backgroundImg.imageUrl}
        width={pageConfig.backgroundImg.imageWidth}
        height={pageConfig.backgroundImg.imageHeight}
        style={{
          width: adaptiveStyle.bgImageWidth,
          height: adaptiveStyle.bgImageHeight,
          objectFit: 'cover',
          objectPosition: 'top',
        }}
      />
      <div
        className={style.productScrollContainer}
        style={{
          top: adaptiveStyle.productListTop,
          left: '0px',
          right: '0px',
          position: 'absolute',
        }}
      >
        <div
          className={style.productList}
          style={{
            paddingLeft: adaptiveStyle.gap,
            // gap: adaptiveStyle.gap,
          }}
        >
          {pageConfig.data.length
            ? pageConfig.data.map((item: any, index: number) => {
                const productData = {
                  type: ProductType.TYPE_1,
                  width: adaptiveStyle.productCardWidth,
                  height: adaptiveStyle.productCardHeight,
                  skuName: item.skuName,
                  skuId: item.skuId,
                  realPrice: item.realPrice,
                  originalPrice: item?.originalPriceV2,
                  originalPriceTips: item?.originalPriceDesc,
                  currency: localInfo?.currencyCode || '',
                  languageCode: localInfo?.languageCode || '',
                  trackingPointParams: genEventTrackingInfo(item, index),
                  // style
                  containerStyle: {
                    backgroundColor: '#fff',
                    marginRight: adaptiveStyle.gap,
                  },
                  skuImgKeyParams: {
                    imgUrlKey: item?.imageUrl,
                    width: 200,
                    height: 200,
                  },
                  skuImgStyle: {
                    width: adaptiveStyle.skuImgWidth,
                    height: adaptiveStyle.skuImgHeight,
                    borderRadius: '4px',
                    alignSelf: 'center',
                  },
                  priceStyle: {
                    //@ts-ignore
                    textAlign: 'center' as TextAlign,
                    marginTop: '8px',
                  },
                  realPriceJDIPriceParams: {
                    symbolStyle: { fontSize: '16px' },
                    integerStyle: { fontSize: '16px' },
                    decimalPointStyle: { fontSize: '16px' },
                    decimalPlaceStyle: { fontSize: '16px' },
                    containerStyle: { display: 'block', height: '22px', lineHeight: '22px' },
                  },
                  originalPriceJDIPriceParams: {
                    containerStyle: {
                      fontSize: '10px',
                      height: '12px',
                      lineHeight: '12px',
                      fontWeight: '500',
                      marginTop: '0px',
                    },
                  },
                  originalPriceStyle: {
                    fontSize: '10px',
                  },
                };
                return <ProductCard key={index} productData={productData} />;
              })
            : null}
        </div>
      </div>
    </div>
  );
}
